export default "__VITE_PUBLIC_ASSET__3a9c8bf5__"